export default __webpack_public_path__ + "static/website-icon-529d75fe872242529a1bbf77c12ab817.png";